/**
 * Coerces form-input values to numbers before posting to the API.
 * Form inputs produce strings; API zod schemas require numbers. Empty strings
 * become null so nullable fields stay nullable and required fields surface
 * their "required" error from the backend instead of a type mismatch.
 *
 * @param {unknown} v
 * @returns {number | null | undefined | unknown}
 */
export default function toNumber(v) {
  if (v === null || v === undefined || typeof v === 'number') return v;
  if (typeof v === 'string') {
    const trimmed = v.trim();
    if (trimmed === '') return null;
    const n = Number(trimmed);
    return Number.isNaN(n) ? v : n;
  }
  return v;
}
